import * as React from "react";
import { useHistory } from "react-router-dom";
import { CoachOption, CoachPicker } from "@/containers/Coach/PromptStudio/components/CoachPicker";
import { ScopeToggle } from "@/containers/Coach/PromptStudio/components/ScopeToggle";
import { PromptStudioScope, usePromptStudioScope } from "@/containers/Coach/PromptStudio/PromptStudioScope";
import { PROMPT_STUDIO_TABS, PromptStudioHeader } from "@/containers/Coach/PromptStudio/components/PromptStudioHeader";
import { URLS } from "@/utils/routes";

export type AdminPromptStudioTab = "designs" | "backgrounds";

const TAB_URLS: Record<AdminPromptStudioTab, string> = {
  designs: URLS.admin.promptStudio,
  backgrounds: URLS.admin.promptStudioBackgrounds,
};

interface AdminPromptStudioHeaderProps {
  tab: AdminPromptStudioTab;
  /** The tab's own buttons, after the scope controls. */
  actions?: React.ReactNode;
  /** Runs instead of the plain store update, for tabs that reset their own filters on a scope change. */
  onScopeChange?(scope: PromptStudioScope): void;
  onCoachChange?(coach: CoachOption | null): void;
}

/**
 * The admin Prompt Studio section header: Designs | Backgrounds tabs and the Global | Coach scope
 * both tabs share.
 */
export const AdminPromptStudioHeader: React.FC<AdminPromptStudioHeaderProps> = ({
  tab,
  actions,
  onScopeChange,
  onCoachChange,
}) => {
  const history = useHistory();
  const { scope, coach, setScope, setCoach } = usePromptStudioScope();

  return (
    <PromptStudioHeader
      tabs={PROMPT_STUDIO_TABS}
      selectedTab={tab}
      onTabChange={key => key !== tab && history.push(TAB_URLS[key as AdminPromptStudioTab])}
      actions={
        <>
          <ScopeToggle scope={scope} onScopeChange={onScopeChange ?? setScope} />
          {scope === "coach" && <CoachPicker coach={coach} onCoachChange={onCoachChange ?? setCoach} />}
          {actions}
        </>
      }
    />
  );
};
